import { Component, Input } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup } from '@angular/forms';
import { ArrHlp } from 'src/lib/fliko/helpers/array.helper';
import { SubscribeComponent } from 'src/app/shared/classes/subscribe-component';
import { LocLabel } from '../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-form-requirement',
  templateUrl: './form-requirement.component.html',
  styleUrls: ['./form-requirement.component.scss']
})
export class FormRequirementComponent extends SubscribeComponent {
  @Input() controlName?: string;
  @Input() control?: AbstractControl;
  @Input() key?: string | string[];
  @Input() labelKey?: string | LocLabel | null;

  public fulfilled = false;

  constructor(private controlContainer: ControlContainer) {
    super();
  }

  ngOnInit(): void {
    if (!this.control && this.controlName) {
      this.control = (this.controlContainer.control as FormGroup).controls[this.controlName];
    }

    this.subscription$.add(
      this.control?.valueChanges.subscribe(() => {
        this.fulfilled = true;
        for (const key of ArrHlp.make(this.key)) {
          if (this.control?.errors && this.control.errors[key]) {
            this.fulfilled = false;
            break;
          }
        }
      })
    );
  }
}
